/**
 * Print utility functions
 */

const PRINT_STYLES = `
  @media print {
    body {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100vh;
      margin: 0;
    }
    img {
      max-width: 100%;
      height: auto;
    }
  }
`;

/**
 * Opens a new window and prints its content
 * @param {string} dataUrl - The data URL to print
 * @returns {Promise} A promise that resolves when printing is complete
 */
export const printDataUrl = (dataUrl) => {
  return new Promise((resolve, reject) => {
    try {
      const printWindow = window.open('', '_blank');
      if (!printWindow) {
        throw new Error('Could not open print window');
      }

      printWindow.document.write(`
        <html>
          <head>
            <style>${PRINT_STYLES}</style>
          </head>
          <body>
            <img 
              src="${dataUrl}" 
              onload="window.print(); window.close(); window.opener.postMessage('print-complete', '*');"
              onerror="window.opener.postMessage('print-error', '*');"
            />
          </body>
        </html>
      `);
      printWindow.document.close();

      let isResolved = false;
      let checkWindowInterval = null;
      let timeout = null;

      const handleMessage = (event) => {
        if (event.data === 'print-complete') {
          // eslint-disable-next-line no-use-before-define
          cleanup();
          resolve();
        } else if (event.data === 'print-error') {
          // eslint-disable-next-line no-use-before-define
          cleanup();
          reject(new Error('Failed to load image for printing'));
        }
      };

      const cleanup = () => {
        if (!isResolved) {
          isResolved = true;
          window.removeEventListener('message', handleMessage);
          if (checkWindowInterval) clearInterval(checkWindowInterval);
          if (timeout) clearTimeout(timeout);
        }
      };

      // Check if print window is closed (user canceled or closed manually)
      checkWindowInterval = setInterval(() => {
        if (printWindow.closed) {
          cleanup();
          resolve(); // Resolve even if window was closed (user might have printed or canceled)
        }
      }, 500);

      // Timeout after 30 seconds to prevent infinite waiting
      timeout = setTimeout(() => {
        cleanup();
        if (!printWindow.closed) {
          printWindow.close();
        }
        resolve(); // Resolve on timeout
      }, 30000);

      window.addEventListener('message', handleMessage);
    } catch (error) {
      reject(error);
    }
  });
};
